import { Linkedin, Twitter, Facebook, MessageCircle, Link2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";

export const ShareButtons = ({ url, title }) => {
  const { t } = useLang();
  const u = encodeURIComponent(url);
  const tt = encodeURIComponent(title);

  const links = [
    { key: "linkedin", label: "LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}` },
    { key: "twitter", label: "X", Icon: Twitter, href: `https://twitter.com/intent/tweet?url=${u}&text=${tt}` },
    { key: "facebook", label: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
    { key: "whatsapp", label: "WhatsApp", Icon: MessageCircle, href: `https://wa.me/?text=${tt}%20${u}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t("blogUi.copied"));
    } catch (e) {
      toast.error("Copy failed");
    }
  };

  return (
    <div data-testid="share-buttons" className="flex items-center gap-3 flex-wrap">
      <span className="font-accent text-[11px] uppercase tracking-[0.2em] text-muted-foreground">{t("blogUi.share")}</span>
      {links.map(({ key, label, Icon, href }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={`share-${key}`}
          className="w-9 h-9 flex items-center justify-center border border-border/60 text-foreground/70 hover:border-primary hover:text-primary transition-all duration-300"
        >
          <Icon size={16} />
        </a>
      ))}
      <button
        onClick={copy}
        aria-label={t("blogUi.copied")}
        data-testid="share-copy"
        className="w-9 h-9 flex items-center justify-center border border-border/60 text-foreground/70 hover:border-primary hover:text-primary transition-all duration-300"
      >
        <Link2 size={16} />
      </button>
    </div>
  );
};

export default ShareButtons;
